// extracted by mini-css-extract-plugin
export default {"ticket":"DZAFWA","discount":"Zd43Pu","row":"PpAZVE","name":"dYbqUP","singlePrice":"mqufRn","price":"QyuWO9","quantity":"L6douF","total":"HcAHhZ","priceItem":"hpjSnp"};